/** Return the display name used for a Google Tag Manager data-layer entry. */
export function extractDataLayerEventName(data) {
    if (typeof data.event === 'string')
        return data.event;
    if (typeof data['gtm.start'] !== 'undefined')
        return 'gtm.start';
    const uniqueEventId = data['gtm.uniqueEventId'];
    if (typeof uniqueEventId === 'string' || (typeof uniqueEventId === 'number' && Number.isFinite(uniqueEventId))) {
        return `gtm.event.${uniqueEventId}`;
    }
    if (typeof uniqueEventId !== 'undefined')
        return 'gtm.event';
    return null;
}
